import React from "react"
import { GatsbyImage } from "gatsby-plugin-image"

export const WizardTypeRefinementItem = ({
  name,
  label,
  image,
  image_faint,
  isRefined,
  proceed,
  set_current_wizard_service_type_refinement,
}) => {
  const refine_type = () => {
    set_current_wizard_service_type_refinement(name)
    proceed()
  }

  return (
    <div
      className="column"
      onClick={refine_type}
      aria-label="Refine Search"
      role="button"
      tabIndex="-1"
      onKeyDown={refine_type}
    >
      <div
        className={`tender-wizard-service-type-picker is-clickable mx-auto${
          isRefined ? " is-refined" : ""
        }`}
      >
        <GatsbyImage
          {...{
            className: "tender-wizard-service-type-picker-image",
            alt: name,
            image,
          }}
        />
        <GatsbyImage
          {...{
            className: "tender-wizard-service-type-picker-image is-faint",
            alt: name,
            image: image_faint,
          }}
        />
      </div>
      <p
        className="title is-6 has-text-mitternachtsblau has-text-centered"
        dangerouslySetInnerHTML={{ __html: label }}
      ></p>
    </div>
  )
}
